"use client";

import React, { useState } from 'react';
import Image from 'next/image';

interface PanelModalProps {
    children: React.ReactNode;
}

export default function PanelModal({ children }: PanelModalProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
            <div onClick={toggleModal} className="cursor-pointer">
                {children}
            </div>
            
            {isModalOpen && (
                <div
                    className="fixed inset-0 bg-slate-950/90 backdrop-blur-sm flex items-center justify-center z-[100] p-4 cursor-pointer"
                    onClick={toggleModal}
                >
                    <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
                        <Image
                            src="/panel.png"
                            alt="Panel"
                            width={1600}
                            height={900}
                            className="rounded-2xl shadow-2xl"
                        />
                    </div>
                </div>
            )}
        </>
    );
}
